module.exports = __webpack_public_path__ + "e5d60e1a527fc7178bff1e3d763633ea.svg";